module.exports = __webpack_public_path__ + "img/dark-mode.dd912fb0.svg";